import { Link } from "react-router-dom";

export const Terms = () => {
  return (
    <section className="af-section" data-testid="terms-page">
      <div className="af-container" style={{ maxWidth: 820 }}>
        <div className="af-eyebrow">Legal</div>
        <h1 className="af-h2" style={{ marginTop: 14, marginBottom: 24 }}>Terms</h1>

        <div className="af-lede" style={{ display: "grid", gap: 16, color: "#cfd3dc" }}>
          <p>
            These terms apply to the AithorityForge Solutions Ltd. website at aithorityforge.com.
          </p>
          <p>
            This website is provided for general information about our company and the products we are building.
            Product descriptions on this site may change as our products evolve.
          </p>

          <h2 style={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700, marginTop: 12 }}>Product notes</h2>
          <p>
            PIN is research intelligence only. PIN is not medical advice.
          </p>
          <p>
            SoulScript is not therapy, not medical advice, and not a replacement for professionals.
          </p>
          <p>
            Clip2SOP does not certify, approve, or guarantee that any work is correct. It is a tool for documenting
            and reviewing work.
          </p>

          <h2 style={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700, marginTop: 12 }}>No warranties</h2>
          <p>
            This website and the information on it are provided as-is, without warranties of any kind, to the extent
            permitted by applicable law.
          </p>

          <h2 style={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700, marginTop: 12 }}>Contact</h2>
          <p>
            For questions about these terms, contact{" "}
            <a href="mailto:stefan@aithorityforge.com" style={{ color: "#fff" }}>stefan@aithorityforge.com</a>.
          </p>

          <p style={{ color: "var(--af-text-muted)", fontSize: "0.9rem", marginTop: 18 }}>
            AithorityForge Solutions Ltd. — Regina, Saskatchewan, Canada.
          </p>

          <div style={{ marginTop: 24 }}>
            <Link to="/" className="af-btn af-btn-ghost" data-testid="terms-back-home">Back to home</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
